import type { RedcatAnalyticsStore } from '../types/store';
import type { SignupEntryPoint, SignupMethod } from '../types/signup';
import { SignupTrackEventName } from '../types/signup';
import type { SignupTrackEvent } from '../types/events/track';

export const trackSignupStarted = (
  track: RedcatAnalyticsStore['track'],
  {
    entryPoint,
    signupMethod,
    configuredFields,
  }: {
    entryPoint: SignupEntryPoint;
    signupMethod: SignupMethod;
    configuredFields: string[];
  },
) => {
  const event: SignupTrackEvent = {
    name: SignupTrackEventName.Started,
    properties: {
      entry_point: entryPoint,
      signup_method: signupMethod,
      configured_fields: configuredFields,
    },
  };

  track(event);
};
